import React from 'react';
import PropTypes from 'prop-types';

import css from './index.scss';

const Tooltip = ({
    content,
    className,
    useDefaultStyle = true
}) => (
    <div className={`
        ${css.tooltip}
        ${className}
        ${useDefaultStyle ? css.tooltip__defaultStyle : undefined}
    `}>
        {content}
    </div>
);

Tooltip.propTypes = {
    /*
     Element displayed within tooltip
     */
    content: PropTypes.element,
    /*
     Top level style modifier
     */
    className: PropTypes.string,
    /**
     * Allows for consumer to quickly implement a default style for tooltip
     */
    useDefaultStyle: PropTypes.bool
};

export default Tooltip;



// WEBPACK FOOTER //
// ./app/components/tooltip/index.js